import type { BatchListRow } from '@ctcells/contract'
import { t } from '@ctcells/i18n'

import type { Column } from '../../atoms/DataTable.tsx'

/**
 * 「시료 수」 열 — 작업 목록과 이력이 **같은 함수**를 쓴다(두 표가 같은 값을 다르게 말하지 않게).
 *
 * 🔴 시료 수는 `Batch.sample_count` — 서버가 조회 때 센 값이다. `0` 은 사실이라 `0` 으로 적는다.
 * ⚠ 이 파일은 종전 `batchOwnerColumns.tsx`(작업자 + 시료 수)다. 「작업자」는 2026-09-30 에 admin 전용으로
 *   되살아나 `batchOwnerColumn.tsx` 로 따로 섰다.
 */
export function batchSampleCountColumn(): Column<BatchListRow> {
  return {
    key: 'sampleCount',
    header: t('column.sampleCount'),
    nowrap: true,
    // 수 열은 내용 폭만 쓴다(eric 2026-09-30 · `Column.width`)
    width: 'fit',
    sort: 'number',
    sortValue: (row) => row.sample_count,
    /*
     * 🔴 **왼쪽 정렬이다**(2026-09-30 · eric 「컬럼 명 조화되게」). 목록 · 이력 표는 남는 폭을 모든 열이 똑같이
     *    나눈다(`DataTable.columnWidths='even'`) — 여백이 칸 오른쪽에 붙는데, 이 열만 오른쪽 정렬이면 여백이 값
     *    «앞»으로 가 앞 열과의 간격이 두 배 · 뒤 열과는 0 이 된다(1440 실측). 한두 자리 수라 자리 맞춤 이득도 없다.
     */
    cell: (row) => <span className="mono num">{String(row.sample_count)}</span>,
  }
}
